import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionProps {
  id?: string;
  className?: string;
  children: ReactNode;
}

export function Section({ id, className, children }: SectionProps) {
  return (
    <section
      id={id}
      className={cn(
        'relative scroll-mt-16 overflow-hidden border-t border-white/[0.04] py-20 lg:py-32',
        className,
      )}
    >
      <div className="container relative z-10">{children}</div>
    </section>
  );
}

interface SectionTitleProps {
  kicker?: string;
  kickerClassName?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
}

export function SectionTitle({
  kicker,
  kickerClassName,
  subtitle,
  children,
  className,
}: SectionTitleProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.5 }}
      className={cn('mx-auto mb-12 max-w-2xl text-center', className)}
    >
      {kicker && (
        <p
          className={cn(
            'mb-6 font-mono text-xs uppercase tracking-wider text-primary/80',
            kickerClassName,
          )}
        >
          {kicker}
        </p>
      )}
      <h2 className="text-3xl font-bold tracking-tight text-white lg:text-5xl">{children}</h2>
      {subtitle && <p className="mt-4 text-lg leading-relaxed text-slate-400">{subtitle}</p>}
    </motion.div>
  );
}
